const FormRegionTitle = (props) => {
  return <div className={props.className} style={{ margin: '0 0 16px 0', padding: 10, backgroundColor: '#f8f8f8', fontSize: '14px', fontWeight: 700 }}>{props.children}</div>;
};

export default FormRegionTitle;
